// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2_5_Y","loaderOuter":"PageOverlayLoader_loaderOuter__1VJmS"};